import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiFacebook, FiInstagram, FiTwitter, FiLinkedin, FiMapPin } = FiIcons;

const Footer = () => {
  const socialLinks = [
    { icon: FiFacebook, label: "Facebook" },
    { icon: FiInstagram, label: "Instagram" },
    { icon: FiTwitter, label: "Twitter" },
    { icon: FiLinkedin, label: "LinkedIn" }
  ];

  return (
    <footer className="py-12 relative bg-black">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="backdrop-blur-xl bg-black/60 rounded-2xl p-8 border border-orange-500/30"
        >
          <div className="text-center mb-8">
            <h3 className="text-2xl font-bold text-white mb-4">SeetaLuxuryEscape</h3>
            <p className="text-orange-200 mb-6">Proudly serving Canadian travelers coast to coast.</p>
            
            <div className="flex justify-center space-x-6 mb-8">
              {socialLinks.map((social, index) => (
                <motion.a
                  key={index}
                  href="#"
                  whileHover={{ scale: 1.2, y: -2 }}
                  whileTap={{ scale: 0.9 }}
                  className="w-12 h-12 rounded-full backdrop-blur-xl bg-black/40 border border-orange-500/30 flex items-center justify-center hover:bg-orange-500/20 hover:border-orange-400/50 transition-all duration-300"
                  aria-label={social.label}
                >
                  <SafeIcon icon={social.icon} className="text-white text-xl" />
                </motion.a>
              ))}
            </div>
          </div>

          <div className="border-t border-orange-500/30 pt-8 text-center">
            <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
              <p className="text-gray-400 text-sm">
                © 2024 SeetaLuxuryEscape. All rights reserved.
              </p>
              <div className="flex gap-6 text-gray-400 text-sm">
                <a href="#" className="hover:text-orange-400 transition-colors">Privacy Policy</a>
                <a href="#" className="hover:text-orange-400 transition-colors">Terms of Service</a>
              </div>
            </div>
            
            <div className="mt-4 flex items-center justify-center gap-2 text-gray-400 text-sm">
              <SafeIcon icon={FiMapPin} className="text-lg" />
              <span>Toronto, Ontario • Serving all of Canada</span>
            </div>
          </div>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;